import React, { useRef } from 'react'
import AddFileIcon from './../../../icons/plusicon';
import DeletefileIcon from './../../../icons/DeletefileIcon'
export default function UploadForm({ item, handleImage,deleteImage,iconDelete,isboth }) {
    const ref = useRef(null)
    return (
        <>
        <div className={`input_file ${(iconDelete || isboth) && (item.inSite || item.image || item.media) ? 'active' : ''}`}>
            <input
                type="file"
                id={item._id}
                ref={ref}
                style={{ display: 'none' }}
                onChange={handleImage}
                accept={isboth ? ".png, .jpg, .jpeg, video/mp4" : ".png, .jpg, .jpeg"}
                value={""}
            />
            <span
                onClick={() => {
                    ref.current.click();
                }}
            ><AddFileIcon /></span>
        </div>
        {(item.inSite === '' || item.image === '' || item.media === '') ? '' : (iconDelete || isboth) &&
            <span className="remove_file pointer"
                onClick={deleteImage}
            ><DeletefileIcon /></span>
        }
        </>
    )
}
